import type { AttackPokemonData } from './attack';
import type { Move } from './move';
import type { otherSetting } from './other-setting';

export type DamageCategory = 'survive' | 'random' | 'guaranteed' | 'invalid';

export interface SpeedModifiers {
  scarf: boolean;
  tailwind: boolean;
  paralysis: boolean;
}

export interface OpponentSpeedSettings {
  self: SpeedModifiers;
  opponent: SpeedModifiers;
  isTrickRoom: boolean;
}

export const createOpponentSpeedSettings = (): OpponentSpeedSettings => ({
  self: {
    scarf: false,
    tailwind: false,
    paralysis: false,
  },
  opponent: {
    scarf: false,
    tailwind: false,
    paralysis: false,
  },
  isTrickRoom: false,
});

export interface ComprehensiveSectionState {
  enabled: boolean;
  collapsed: boolean;
}

export interface ComprehensiveUiFlags {
  commonConditions: ComprehensiveSectionState;
  damageDealt: ComprehensiveSectionState;
  damageTaken: ComprehensiveSectionState;
  speed: ComprehensiveSectionState;
  opponentList: {
    showTags: boolean;
    showMoveCount: boolean;
  };
}

export interface ComprehensiveGlobalConditions extends otherSetting {
  rule?: 'single' | 'double';
  teraEnabled?: boolean;
  levelFixed?: number;
  criticalEnabled?: boolean;
}

export interface OpponentCard {
  id: string;
  pokemonId: number;
  speciesId: number;
  formId?: number | null;
  name: string;
  level: number;
  otherSetting?: otherSetting;
  speedSettings?: OpponentSpeedSettings;
  defenseProfile?: AttackPokemonData;
  offenseProfile?: AttackPokemonData;
  assumedMoveIds: number[];
  assumedMoves?: Move[];
  tags?: string[];
  pinned?: boolean;
  notes?: string;
}

export interface ComprehensiveOpponentListData {
  opponents: OpponentCard[];
  selectedOpponentId: string | null;
  lastTouchedOpponentId: string | null;
  uiFlags: ComprehensiveUiFlags;
  globalConditions: ComprehensiveGlobalConditions;
  timestamp: string;
}

export const DEFAULT_COMPREHENSIVE_UI_FLAGS: ComprehensiveUiFlags = {
  commonConditions: { enabled: true, collapsed: false },
  damageDealt: { enabled: true, collapsed: false },
  damageTaken: { enabled: true, collapsed: false },
  speed: { enabled: true, collapsed: false },
  opponentList: { showTags: true, showMoveCount: true },
};
